import { Helmet } from 'react-helmet';
import FAQItem from './FAQItem';




const FAQItems = ({ questions }) => {

    return (
        <>
            <Helmet
                script={[
                    {
                        type: "application/ld+json",
                        innerHTML: JSON.stringify({
                            "@context": "http://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": questions.map(item => ({
                                "@type": "Question",
                                "name": item.title,
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": item.text
                                }
                            }))
                        })
                    }
                ]}
            />

            <div className='faq-items'>
                {questions?.map((item, index) => (
                    <FAQItem key={index} item={item} />
                ))}
            </div>
        </>

    );
}

export default FAQItems;